import PropTypes from "prop-types";
import { Container, Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SurveyForm = ({
  interactionIdKey: _interactionIdKey,
  filteredParams: _filteredParams = {},
}) => {
  const theme = useTheme();

  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{ bgcolor: theme.palette.white, borderRadius: "10px" }}
    >
      <Box sx={{ px: 3, py: 4, textAlign: "center" }}>
        <Typography variant="h2" sx={{ fontSize: "25px", mb: 2 }}>
          Pre-Text Survey
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          This is a placeholder for the pre-text/pre-SMS survey form.
        </Typography>
        <Button
          variant="contained"
          disableElevation
          sx={{
            borderRadius: 50,
            px: 4,
            py: 1.5,
            bgcolor: theme.palette.primary.main,
            textTransform: "none",
            fontWeight: "bold",
            ":hover": {
              bgcolor: theme.palette.secondary.dark,
            },
          }}
        >
          Start Text
        </Button>
      </Box>
    </Container>
  );
};

SurveyForm.propTypes = {
  interactionIdKey: PropTypes.string,
  filteredParams: PropTypes.object,
};

export default SurveyForm;
